<div class="background-signing">

</div>
<div class="container-fluid overlay">

  <div class="row">

    <div class="col-sm-12 col-12 signLogo" >
      <svg class="logo-align img-fluid" id="Component_80_234" data-name="Component 80 – 234" xmlns="http://www.w3.org/2000/svg" width="226.3" height="53.357" viewBox="0 0 226.3 53.357">
        <g id="Group_725" data-name="Group 725">
          <g id="Group_715" data-name="Group 715" transform="translate(189.154)">
            <g id="Group_714" data-name="Group 714">
              <path id="Path_93" data-name="Path 93" d="M531.136,308.1c0-10.7,7.876-18.9,18.967-18.9,8.992,0,17.063,5.447,18.178,15.1H556.8c-.853-3.478-3.741-4.792-6.694-4.792-4.921,0-7.678,3.544-7.678,8.6,0,5.185,2.953,8.6,7.613,8.6,3.018,0,5.906-1.444,6.759-4.857h11.484c-1.18,9.976-9.45,15.16-18.243,15.16C539.012,327,531.136,318.8,531.136,308.1Z" transform="translate(-531.136 -289.199)" fill="#fff"/>
            </g>
          </g>
          <g id="Group_717" data-name="Group 717" transform="translate(40.823)">
            <g id="Group_716" data-name="Group 716">
              <path id="Path_94" data-name="Path 94" d="M353.757,290.052l-.066,36.1H342.535v-3.872A12.513,12.513,0,0,1,332.362,327c-9.188,0-16.276-7.744-16.276-18.9,0-11.223,7.219-18.9,16.211-18.9a12.547,12.547,0,0,1,10.3,4.923v-4.07ZM342.6,308.1c0-4.988-3.282-8.269-7.613-8.269s-7.613,3.282-7.613,8.269c0,5.053,3.347,8.269,7.613,8.269C339.319,316.37,342.6,313.154,342.6,308.1Z" transform="translate(-316.086 -289.199)" fill="#fff"/>
            </g>
          </g>
          <g id="Group_719" data-name="Group 719" transform="translate(81.721 0.853)">
            <g id="Group_718" data-name="Group 718">
              <path id="Path_95" data-name="Path 95" d="M414.493,290.436l-23.036,52.5H379.579l9.385-21.4-13.585-31.108h11.879l7.613,18.836,7.744-18.836Z" transform="translate(-375.379 -290.436)" fill="#fff"/>
            </g>
          </g>
          <g id="Group_721" data-name="Group 721" transform="translate(119.546)">
            <g id="Group_720" data-name="Group 720">
              <path id="Path_96" data-name="Path 96" d="M467.889,290.052l-.065,36.1H456.667v-3.872A12.513,12.513,0,0,1,446.495,327c-9.188,0-16.277-7.744-16.277-18.9,0-11.223,7.22-18.9,16.21-18.9a12.547,12.547,0,0,1,10.3,4.923v-4.07ZM456.733,308.1c0-4.988-3.282-8.269-7.613-8.269s-7.613,3.282-7.613,8.269c0,5.053,3.347,8.269,7.613,8.269C453.451,316.37,456.733,313.154,456.733,308.1Z" transform="translate(-430.218 -289.199)" fill="#fff"/>
            </g>
          </g>
          <g id="Group_723" data-name="Group 723" transform="translate(163.244)">
            <g id="Group_722" data-name="Group 722">
              <path id="Path_97" data-name="Path 97" d="M517.263,289.4v11.485a19.448,19.448,0,0,0-2.231-.131c-5.25,0-10.3,1.575-10.3,9.778v15.62H493.571v-36.1h6.673a4.483,4.483,0,0,1,4.483,4.483v1.1a11.074,11.074,0,0,1,10.5-6.432A8.468,8.468,0,0,1,517.263,289.4Z" transform="translate(-493.571 -289.199)" fill="#fff"/>
            </g>
          </g>
          <g id="Group_724" data-name="Group 724">
            <path id="Path_98" data-name="Path 98" d="M263.919,305.677H256.9v36.879h11.156v-20.28A12.741,12.741,0,0,0,278.295,327c9.187,0,16.275-7.744,16.275-18.9,0-11.223-7.219-18.9-16.21-18.9H256.9v3.482a7.151,7.151,0,0,0,7.151,7.151h11.619c4.332,0,7.613,3.282,7.613,8.269,0,5.053-3.347,8.269-7.613,8.269a7.415,7.415,0,0,1-7.524-6.866,4.425,4.425,0,0,0-1.161-2.519h0A4.247,4.247,0,0,0,263.919,305.677Z" transform="translate(-256.9 -289.199)" fill="#fff"/>
          </g>
        </g>
      </svg>

<!--      <img class="logo-align img-fluid"  src="{{dataManager.loginlogo}}" />-->
    </div>
  </div>

  <div class="row">
    <div class="container-card ipad_iphone">


      <ng-container *ngIf="topErrorMessage">
        <div class="row err" *ngFor="let obj of keys1 " >
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngFor="let value of obj " >
            <p class="col-sm-12 col-md-12 col-lg-12 col-xl-12 error" id="err" >{{value}}</p>
          </div>
        </div>
      </ng-container>
      <div class="row" *ngIf="!topErrorMessage">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 error mb-1"> {{errorMsg}}</div>
      </div>
      <br>
        <h3 class="text-center heading2">Reset password</h3>
      <div class="form-group row">
        <span class="error_sign col-2" id="password1">!</span>
        <div class="col-sm-12 landscape_view">
          <div class="row">
            <div class="col-md-4">
              <label for="password" class="l_label">Password:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input type="password" class="form-control" (keydown)="onKeydown($event)" name="password" required
                     [(ngModel)]="password" id="password" placeholder="********"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <span class="error_sign col-2" id="password_confirmation1">!</span>
        <div class="col-sm-12 landscape_view">
          <div class="row">
            <div class="col-md-8">
              <label for="password" class="l_label">Confirm Password:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <input type="password" class="form-control" (keydown)="onKeydown($event)" name="password_confirmation" required
                     [(ngModel)]="password_confirmation" id="password_confirmation" placeholder="********"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row pt-3 pb-2 continue-btn-m">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <button type="submit" [disabled]="loadFlag" class="bt_signin form form-control" (click)="resetpass()" >Reset Password<i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-5 col-md-5 col-sm-5 pt-3 container justify-content-center text-center privacy-m" >
      <div class="col">
        <a href="https://www.payarc.com/privacy-policy" class="privacy" target="_blank">Privacy Policy</a><span class="p_line"> | </span><a href="https://www.payarc.com/company/terms-and-conditions" class="privacy" target="_blank">Terms &amp; Conditions</a>
      </div>

    </div>
  </div>
</div>


